import axios from 'axios'
import config from 'config'

const instanceCommon = axios.create({
  baseURL: config.API_URL,
  timeout: 300000,
})

export default instanceCommon
